<template>
  <div class="d-flex flex-column justify-center ma-0 pa-0">
    <!-- file -->
    <input
      ref="file"
      :accept="accept"
      :disabled="disabled"
      hidden
      type="file"
      @change="fileChange"
    />
    <div
      v-if="!isShowFile"
      class="file__upload text-center full-width py-4"
      :class="[drag ? 'drag' : '']"
      @click="goAddFile"
      @dragenter="
        if (disabled) return
        overrideDefault($event)
        hoverDrag()
      "
      @dragleave="
        if (disabled) return
        overrideDefault($event)
        hoverDragEnd()
      "
      @dragover="
        if (disabled) return
        overrideDefault($event)
        hoverDrag()
      "
      @drop="
        if (disabled) return
        overrideDefault($event)
        hoverDragEnd()
        fileChange($event)
      "
    >
      <v-icon size="30">mdi-paperclip</v-icon>
      <div class="mt-2">{{ title }}</div>
    </div>
    <!-- end file -->
    <template v-else>
      <div class="d-flex justify-center" style="position: relative">
        <v-card
          class="fill-width d-flex justify-center align-center border_radius_default none_box-shadow padding-5"
          height="auto"
          tile
          width="100%"
        >
          <v-img aspect-ratio="1.7" :src="url" />
        </v-card>
        <div class="remove">
          <base-button icon type-action="delete" @click.stop="onRemove">
          </base-button>
        </div>
      </div>
    </template>
    <VMessages class="pt-2" color="error" :value="errorBucket" />
  </div>
</template>
<script>
import VInput from 'vuetify/lib/components/VInput/VInput.js'
export default {
  extends: VInput,
  props: {
    value: {
      required: false,
    },
    title: {
      required: true,
      type: String,
    },
    accept: { type: String, default: 'image/*' },
  },
  data: () => ({
    file: [],
    drag: false,
    url: '',
  }),
  computed: {
    isShowFile() {
      return this.file || this.url
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        if (!value) {
          this.file = null
          this.url = null
          return
        }
        if (typeof value == 'string') {
          this.url = value
          return
        }
        try {
          this.url = URL.createObjectURL(value)
        } catch (e) {
          console.error(e)
        }
      },
    },
  },
  methods: {
    // inputfile
    //drag event
    hoverDrag() {
      this.drag = true
    },
    hoverDragEnd() {
      this.drag = false
    },
    overrideDefault(e) {
      e.preventDefault()
      e.stopPropagation()
    },
    goAddFile() {
      this.$refs.file.click()
    },
    fileChange(e) {
      let files = e.dataTransfer ? e.dataTransfer.files : e.target.files

      this.file = files[0]
      this.url = URL.createObjectURL(this.file)
      this.$refs.file.value = ''
      this.$emit('input', this.file)
    },
    reset() {
      this.url = ''
      this.file = null
      this.$emit('input', this.file)
    },
    onRemove() {
      this.reset()
    },
  },
}
</script>
<style scoped>
/* effect drag */
.remove {
  position: absolute;
  top: 10px;
  right: 10px;
}
.drag {
  border: 3px dashed var(--v-colorText-base);
}
.file__upload {
  background-color: #eceff1;
  border-radius: 6px;
  cursor: pointer;
}
.v-icon.mdi-paperclip {
  transform: rotate(45deg);
}
.ls_document {
  color: var(--v-colorText-base);
}
@media (max-width: 600px) {
  .file__upload {
    background-color: #eceff1;
    padding-left: 50px !important;
    padding-right: 50px !important;
    border-radius: 6px;
    cursor: pointer;
  }
}
</style>
